import {IntermediatePart} from "../../intermediatePart";

export default class Plant extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'plant';
    this.partName = 'Plant';
    this.translateId = "visualizer.bathroom.plant";
    this.canBeDisabled = true;
  }

}
